module.exports = ['javascript', 'react', 'angular', 'vue'];